import { environment as env } from '../../../environments/environment';
import { Component, OnInit, ChangeDetectionStrategy, Inject, Output, EventEmitter, SecurityContext, ViewChildren } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClientSearchComponent } from '../client-search/client-search.component';
import { AgentSearchComponent } from '../agent-search/agent-search.component';
import { OrganizationSearchComponent } from '../organization-search/organization-search.component';
import { QueryList } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LgvModel } from '../../data-models/longevity.model';


@Component({
    selector: 'lgv-client-picker-modal',
    styleUrls: ['client-picker-modal.component.scss'],
    templateUrl: 'client-picker-modal.component.html',
})

export class ClientPickerModalComponent {

    @Output() OnOKClicked: EventEmitter<string> = new EventEmitter();

    constructor(
        public dialogRef: MatDialogRef<ClientPickerModalComponent>,
        private http: HttpClient,
        @Inject(MAT_DIALOG_DATA) public data: any )
    {
    }

    IsLoading$ = new BehaviorSubject(false);

    OnCancel(): void {
        this.dialogRef.close({action:false});
    }

    OnOK() {
        this.OnOKClicked.emit("");
        this.dialogRef.close({action:true, clientDTO:this.ClientDTO});
    }


    @ViewChildren(ClientSearchComponent) childClientComponent!: QueryList<ClientSearchComponent>;
    @ViewChildren(AgentSearchComponent) childAgentComponent!: QueryList<AgentSearchComponent>;
    @ViewChildren(OrganizationSearchComponent) childOrganizationComponent!: QueryList<OrganizationSearchComponent>;
    SelectedCompany: string = '';
    SelectedAgent: string = '';
    SelectedOrganization: string = '';
    //SelectedClient: string = '';
    ClientDTO: LgvModel.ClientDTO;

    selectCompany(param) {
        this.SelectedCompany = param;
        this.SelectedAgent = '';
        this.SelectedOrganization = '';
        //this.SelectedClient = '';
        this.childAgentComponent.forEach(c => c.reset());
        this.childOrganizationComponent.forEach(c => c.reset());
        this.childClientComponent.forEach(c => c.reset());
    }
    OnOrganizationSelected(event) {
        this.SelectedOrganization = event.id;
    }

    selectAgent(param) {
        this.SelectedAgent = param;

    }

    selectClient(clientDTO: LgvModel.ClientDTO) {
        console.log('clientPickerModal.selectClient()');
        console.log(clientDTO);
        this.ClientDTO = clientDTO;


        // automatically close the dialog
        this.OnOK();
    }
}
